function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#717375"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.045 7.315l2.11.037-.015.904-2.11-.036zm2.815 0l2.11.037-.015.904-2.11-.036zM8.045 10.12l2.11.037-.015.904-2.11-.037zm2.815 0l2.11.037-.015.904-2.11-.037zm-2.815 2.805l2.11.036-.015.905-2.11-.037zm2.815 0l2.11.036-.015.905-2.11-.037zM8.045 15.73l2.11.036-.015.905-2.11-.037zm2.815 0l2.11.036-.015.905-2.11-.037zm4.918-2.32h1.203v.905h-1.203zm0 1.659h1.203v.905h-1.203zm0 1.659h1.203v.905h-1.203zm-11.963-4.17h1.61v.704h-1.61zm0 1.461h1.61v.703h-1.61zm0 1.46h1.61v.703h-1.61zm0 1.46h1.61v.704h-1.61zm0-5.841h1.61v.704h-1.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.773 19.387v-9.194h-4.29V4.677h-1.245a2.763 2.763 0 0 0-2.435-2.435V1h-.613v1.245A2.763 2.763 0 0 0 7.755 4.68H6.509v3.984H2.227V19.39H1V20h19v-.613h-1.227zm-12.256 0H2.84V9.273h3.677v10.114zM10.5 2.84c1.077 0 1.975.8 2.124 1.84H8.375A2.151 2.151 0 0 1 10.5 2.84zm3.37 16.547H7.13V5.29h6.744v14.097h-.004zm4.29 0h-3.677v-8.58h3.677v8.58z",
  stroke: "#717375",
  strokeWidth: 0.5
}));

function SvgOrg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21"
  }, props), _ref);
}

export default SvgOrg;